var _style, _path, _path2, _path3, _path4, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordMask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_435",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.6 18.6",
    style: {
      enableBackground: "new 0 0 18.6 18.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#748B94;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,13.5l2-2c-0.5-0.6-0.8-1.4-0.8-2.3c0-2.1,1.7-3.9,3.9-3.9c0.9,0,1.6,0.3,2.3,0.8l1.8-1.8 c-1.2-0.6-2.6-0.9-4-0.9c-3.8,0-7.1,2.3-8.5,5.8C1.5,11.1,2.7,12.5,4.2,13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,11.6c1.3,0,2.3-1,2.3-2.3v0c0-0.4-0.1-0.8-0.3-1.2l-3.2,3.2C8.4,11.5,8.8,11.6,9.3,11.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,7L9.3,7C8,7,7,8,7,9.3c0,0.4,0.1,0.8,0.3,1.2l3.2-3.2C10.1,7.1,9.7,7,9.3,7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,5l-2,2c0.5,0.6,0.8,1.4,0.8,2.3c0,2.1-1.7,3.9-3.9,3.9h0c-0.9,0-1.7-0.3-2.3-0.8l-1.7,1.7 c2.2,1.1,4.9,1.3,7.4,0.3c2.4-0.9,4.2-2.8,5.2-5.2C17.1,7.5,15.9,6,14.3,5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.2,16.9 1.5,16.2 4.2,13.5 5.2,14.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14.3,5 13.4,4.4 16.3,1.6 17,2.3 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordMask);
export default __webpack_public_path__ + "static/media/password-mask.aaf706a15a865f925385530c6bbd07ea.svg";
export { ForwardRef as ReactComponent };